import { type ReactNode } from 'react';
import { Heading } from '../typography/Heading/Heading';
import { Paragraph } from '../typography/Paragraph/Paragraph';

import styles from './ListItem.module.css';

export type ListItemMainProps = {
  variant: 'default' | 'heading' | 'heading-secondary';
  title: string;
  supporting: Array<{
    icon?: ReactNode;
    text: string;
  }>;
};

export function ListItemMain(props: ListItemMainProps) {
  const { variant, title, supporting } = props;
  switch (variant) {
    case 'heading-secondary': {
      return (
        <>
          <Heading variant="H6">{title}</Heading>
          <ul className={styles.supporting}>
            {supporting.map(({ icon, text }) => {
              return (
                <li
                  key={text}
                  className={`${styles['supporting-item']} ${styles['main-supporting-default']}`}
                >
                  {icon}
                  <Paragraph variant="caption">{text}</Paragraph>
                </li>
              );
            })}
          </ul>
        </>
      );
    }
    case 'heading': {
      return (
        <>
          <Heading variant="H6">{title}</Heading>
          <ul className={styles.supporting}>
            {supporting.map(({ text, icon }) => {
              return (
                <li key={text} className={styles['supporting-item']}>
                  {icon}
                  <Paragraph variant="body">{text}</Paragraph>
                </li>
              );
            })}
          </ul>
        </>
      );
    }
    case 'default': {
      return (
        <>
          <Paragraph variant="body">{title}</Paragraph>
          <ul className={styles.supporting}>
            {supporting.map(({ icon, text }) => {
              return (
                <li
                  key={text}
                  className={`${styles['supporting-item']} ${styles['main-supporting-default']}`}
                >
                  {icon}
                  <Paragraph variant="caption">{text}</Paragraph>
                </li>
              );
            })}
          </ul>
        </>
      );
    }
  }
}
